import React from 'react';
import './style.scss';
import { Link, useNavigate } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Spinner } from 'react-bootstrap';
import { ArrowLeft } from '../../../atoms/icons';

interface Props {
    secondary?: {title: string | undefined, route: string}
    primary: {title: string, route: string};
    title: string | undefined;
    topRightItem?: React.ReactElement | null;
}

const AddHeader: React.FC<Props> = (props) => {
  const {
    primary, secondary, title, topRightItem = null,
  } = props;
  const navigation = useNavigate();
  const onNavigateBack = () => {
    // if (secondary) {
    //   navigation(secondary.route);
    // } else {
    //   navigation(primary.route);
    // }
    navigation(-1);
  };

  return (
    <div className="p-4 px-xl-5">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="d-flex mb-2 align-items-center" style={{ marginTop: '-10px' }}>
            <button
              onClick={onNavigateBack}
              type="button"
              className="border-0 bg-transparent"
              style={{ marginTop: '4px' }}
            >
              <ArrowLeft />
            </button>
            <div className="fw-bold fz-24 ms-3 mt-2">{title ?? <Spinner size="sm" animation="border" />}</div>
          </div>
          <div className="d-flex fz-14 align-items-center">
            <Link
              id="primaryLinkAddHeader"
              className="text-decoration-none text-secondary opacity-50"
              to={primary.route}
            >
              {primary.title}
            </Link>
            <ChevronRightIcon />
            <Link
              id="secondaryLinkAddHeader"
              className={!secondary ? 'd-none' : 'text-decoration-none text-secondary opacity-50'}
              to={secondary?.route ?? ''}
            >
              {secondary?.title ?? <Spinner size="sm" animation="border" />}
            </Link>
            <ChevronRightIcon sx={{ display: secondary ? 'block' : 'none' }} />
            <div>{title ?? <Spinner size="sm" animation="border" />}</div>
          </div>
        </div>
        {topRightItem}
      </div>
    </div>
  );
};

export default AddHeader;
